export default {"src":"/_next/static/media/black-furniture.00faac1b.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};